@if (friend) {
<button class="friends-menu-button" (click)="onMenuClick($event)" mat-button [matMenuTriggerFor]="menu">
  <app-icon class="icon" name="heroEllipsisHorizontal"></app-icon>
</button>
<mat-menu class="actions" #menu="matMenu">
  @if (friend && friend.shareTo !== 'active') {
    <button (click)="shareTo($event)" class="menu-item default" mat-menu-item>Share to</button>
  }
  @if (friend && friend.shareFrom === 'active') {
    <button (click)="stopSharingFrom($event)" class="menu-item" mat-menu-item>Stop sharing from</button>
  }
  @if (friend && (friend.shareFrom !== null) && (friend.shareTo !== null)) {
    <button (click)="removeFriend($event)" class="menu-item delete-item" mat-menu-item>Remove from friends</button>
  }
</mat-menu>
}
